import styled from "styled-components";
import { BodySmall } from "../../../atoms/fonts/Body";
import Colours from "../../../atoms/Colours";
import React from "react";
import { useTranslation } from "react-i18next";

export function AddNoteButton(props: Props) {
  const {t} = useTranslation();
  return <Container onClick={props.onClick}
                    colour={Colours.darkGrey}
                    weight={600}>
    {t('day-notes-dialog.add-note')}
  </Container>
}

interface Props {
  onClick: (e: any) => any;
}

const Container = styled(BodySmall)`
  border: 1px solid ${Colours.mildGrey};
  border-radius: 4px;
  padding: 8px;
  display: flex;
  align-items: center;
  margin-left: auto;
  white-space: nowrap !important;
`
